import { StorageEngine } from './storage-engine';

export class LocalStorageEngine extends StorageEngine {
  protected setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  protected getItem(key: string): any {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return;
    }
  }

  protected removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
